import {
  DistributorType,
  type DistributorSearchItemFragment,
  type StorefinderNodeDistributorFragment,
} from '#graphql-operations'
import type { NuxtSvgSpriteSymbol } from '#nuxt-svg-sprite/runtime'

/**
 * Helpers for store finder related things.
 */
export default async function () {
  const { $texts } = useNuxtApp()
  const isRebranding = await useFeatureFlag()
  /**
   * Get the icon for a distributor type.
   */
  const getDistributorTypeIcon = (
    type: DistributorType,
  ): NuxtSvgSpriteSymbol => {
    switch (type) {
      case DistributorType.Own_boutique:
        return isRebranding ? 'logo-no-claim' : 'logo-shield'
      case DistributorType.Store:
        return 'shopping-bag'
      case DistributorType.Service_center:
        return 'settings'
      case DistributorType.Legacy:
        return 'shopping-bag'
    }
  }

  /**
   * Get the label for a distributor type.
   */
  const getDistributorTypeLabel = (type: DistributorType): string => {
    switch (type) {
      case DistributorType.Own_boutique:
        return $texts('storefinder.orisBoutique', 'Oris Boutique')
      case DistributorType.Store:
        return $texts('storefinder.retailer', 'Retailer')
      case DistributorType.Service_center:
        return $texts('storefinder.service', 'Service')
      case DistributorType.Legacy:
        return $texts('storefinder.legacy', 'Retailer')
    }
  }

  /**
   * Get the distributor types from a store finder item or a distributor node.
   */
  const getDistributorTypes = (
    item: DistributorSearchItemFragment | StorefinderNodeDistributorFragment,
  ): DistributorType[] => {
    const types: DistributorType[] = []

    if (item.isOwnBoutique) {
      types.push(DistributorType.Own_boutique)
    }

    if (item.isStore) {
      types.push(DistributorType.Store)
    }

    if (item.isServiceCenter) {
      types.push(DistributorType.Service_center)
    }

    return types
  }

  return {
    getDistributorTypeIcon,
    getDistributorTypeLabel,
    getDistributorTypes,
  }
}
